export const GTM_CLICK_ON_CASHBACK_OFFER = () => ({
  event: 'interaction_click on a link',
  e_category: 'navigation',
  e_action: 'Click on a link',
  e_label: 'Click on see more',
  amp_event_name: 'Click on a link',
  event_trigger: 'Cashback offer',
  click_element: 'Click on see more',
});
